import {useEffect, useRef, useState} from "react";
import axios from "axios";
import {setError} from "../../../slices/error/ErrorSlice";
import { useDispatch } from "react-redux";
import Pagination from "../../elements/Pagination";
import Modal from "../../elements/Modal";
import {formValid, resetFieldsErrors} from "../../../functions/form";
import {isJsonString} from "../../../functions/functions";

export default function Production() {
    const dispatch = useDispatch();

    const [productionList, setProductionList] = useState([]);
    const[form, setForm] = useState({
        tnved_code: '',
        name_rus: '',
        name_eng: '',
        name_lat: ''
    })
    const[params, setParams] = useState({
        tnved: '',
        name_rus: '',
        name_eng: '',
        name_lat: ''
    });
    const[pagination, setPagination] = useState({
        currentPage: 1,
        pagesCount: 0
    });
    const formRefs = useRef({
        tnved_code: useRef(null),
        name_rus: useRef(null),
        name_eng: useRef(null),
        name_lat: useRef(null)
    });
    const[modalShow, setModalShow] = useState(false);
    const[modalDelShow, setModalDelShow] = useState(false);
    const[editId, setEditId] = useState(null);
    const[del, setDel] = useState({
        id: null,
        name: null
    });

    useEffect(() => {
        let timeout = setTimeout(() => {
            getProductions();
        }, 1000)

        return () => {
            clearTimeout(timeout);
        };
    }, [params]);

    useEffect(() => {
        getProductions();
    }, [pagination.currentPage]);

    function getProductions() {
        axios.get('/api/voc/production-list', {params: {...params, page: pagination.currentPage}})
            .then(res => {
                setProductionList(res.data);
                let headers = {
                    currentPage:    Number(res.headers['x-pagination-current-page']),
                    pagesCount:     Number(res.headers['x-pagination-pages-count'])
                }
                setPagination(headers);
            })
            .catch(e => {
                dispatch(setError(e.response.data));
            })
    }

    function setCurrentPage(page) {
        setPagination({...pagination, currentPage: page});
    }

    function changeParamsHandler(e) {
        let fieldName = e.target.name;
        let value = e.target.value;

        setParams({...params, [fieldName]: value});
    }

    function modalShowToggler() {
        setModalShow(!modalShow);
    }

    function closeModalEntity() {
        setModalShow(!modalShow);
        resetForm();
        resetFieldsErrors(formRefs.current);
        setEditId(null);
    }

    function openModalDelHandler(e) {
        setDel({
            id: Number(e.currentTarget.getAttribute('iid')),
            name: e.currentTarget.previousSibling.previousSibling.previousSibling.previousSibling.innerHTML
        })

        setModalDelShow(!modalDelShow);
    }

    function closeModalDelHandler() {
        setModalDelShow(!modalDelShow);
        setDel({
            id: null,
            name: null
        })
    }

    function resetForm() {
        setForm({
            tnved_code: '',
            name_rus: '',
            name_eng: '',
            name_lat: ''
        })
    }

    function changeFormHandler(e) {
        let fieldName = e.target.name;
        let value = e.target.value;

        setForm({...form, [fieldName]: value});
    }

    function getItemHandler(e) {
        const id = e.currentTarget.getAttribute('iid');
        setEditId(id);

        axios.get(`/api/production/${id}`)
            .then(res => {
                setForm(Object.assign(form, res.data));
                modalShowToggler();
            })
            .catch(e => {
                dispatch(setError(e.response.data));
            })
    }

    function createHandler() {
        axios.post('/api/production/create', form)
            .then(res => {
                console.log('production created');
                getProductions();
                closeModalEntity();
            })
            .catch((e) => {
                if(isJsonString(e.response.data.detail)) {
                    let objErr = JSON.parse(e.response.data.detail);
                    formValid(formRefs.current, objErr);
                } else {
                    dispatch(setError(e.response.data));
                }
            })
    }

    function editHandler() {
        axios.post(`/api/production/${editId}/edit`, form)
            .then(res => {
                console.log('production was updated')
                closeModalEntity();
                getProductions();
            })
            .catch(e => {
                if(isJsonString(e.response.data.detail)) {
                    let objErr = JSON.parse(e.response.data.detail);
                    formValid(formRefs.current, objErr);
                } else {
                    dispatch(setError(e.response.data));
                }
            })
    }

    function delHandler() {
        axios.delete(`/api/production/${del.id}/del`)
            .then(res => {
                closeModalDelHandler();
                getProductions();
            })
            .catch(e => {
                dispatch(setError(e.response.data));
            })
    }

    let rows = productionList.map(item =>
        <tr key={item.id}>
            <td>{item.id}</td>
            <td>{item.tnvedCode}</td>
            <td>{item.nameRus}</td>
            <td>{item.nameEng}</td>
            <td>{item.nameLat}</td>
            <td iid={item.id} onClick={getItemHandler}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil hover" viewBox="0 0 16 16">
                    <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                </svg>
            </td>
            <td iid={item.id} onClick={openModalDelHandler}>
                <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-trash hover red" fill="currentColor"
                     xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                </svg>
            </td>
        </tr>
    )

    return (
        <>
            <Modal
                header={editId ? 'Редактирование' : 'Добавить товар'}
                show={modalShow}
                closeHandler={closeModalEntity}
            >
                <div className="mb-3 textOnInput">
                    <label htmlFor="tnved_code" className="col-auto col-form-label">Код тнвэд</label>
                    <input type="text" name='tnved_code' className="form-control" id="tnved_code"
                           ref={formRefs.current.tnved_code}
                           onChange={changeFormHandler} value={form.tnved_code}
                    />
                </div>
                <div className="mb-3 textOnInput">
                    <label htmlFor="nam_rus" className="col-auto col-form-label">Наименование Рус.</label>
                    <input type="text" name='name_rus' className="form-control" id="name_rus"
                           ref={formRefs.current.name_rus}
                           onChange={changeFormHandler} value={form.name_rus}
                    />
                </div>
                <div className="mb-3 textOnInput">
                    <label htmlFor="name_eng" className="col-auto col-form-label">Наименование Анг.</label>
                    <input type="text" name='name_eng' className="form-control" id="name_eng" ref={formRefs.current.name_eng}
                           onChange={changeFormHandler} value={form.name_eng}
                    />
                </div>
                <div className="mb-3 textOnInput">
                    <label htmlFor="name_lat" className="col-auto col-form-label">Наименование Лат.</label>
                    <input type="text" name='name_lat' className="form-control" id="name_lat"
                           ref={formRefs.current.name_lat}
                           onChange={changeFormHandler} value={form.name_lat}
                    />
                </div>

                <div className='modal-footer-custom d-grid gap-2 d-md-flex justify-content-md-end'>
                    <input type='button' className='btn mb-0 btn-success margin-botom'
                           onClick={editId ? editHandler : createHandler}
                           value="Сохранить"/>
                    <input type='button' className='btn mb-0 btn-danger margin-botom' onClick={closeModalEntity}
                           value='Отмена'/>
                </div>
            </Modal>

            <Modal
                header='Удалить клиента'
                show={modalDelShow}
                closeHandler={closeModalDelHandler}
            >
                <div className="float-none">{del.name}</div>
                <div className='modal-footer-custom d-grid gap-2 d-md-flex justify-content-md-end'>
                    <input type='button' className='btn mb-0 btn-success margin-botom'
                           onClick={delHandler}
                           value='Да'/>
                    <input type='button' className='btn mb-0 btn-danger margin-botom' onClick={closeModalDelHandler}
                           value='Нет'/>
                </div>
            </Modal>

            <h1>Товары</h1>

            <input type='button' className='btn btn-primary margin-botom' onClick={modalShowToggler} value='Добавить'/>

            <table className="table table-striped table-bordered">
                <thead>
                <tr>
                    <th scope="col" style={{width: 95}}>ID</th>
                    <th scope="col" style={{width: 150}}>Код тнвэд</th>
                    <th scope="col">Наименование рус.</th>
                    <th scope="col">Наименование англ.</th>
                    <th scope="col">Наименование лат.</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <input onChange={changeParamsHandler} type="text" name='tnved' className="form-control"
                               placeholder='Поиск'/>
                    </td>
                    <td>
                        <input onChange={changeParamsHandler} type="text" name='name_rus' className="form-control"
                               placeholder='Поиск'/>
                    </td>
                    <td>
                        <input onChange={changeParamsHandler} type="text" name='name_eng' className="form-control"
                               placeholder='Поиск'/>
                    </td>
                    <td>
                        <input onChange={changeParamsHandler} type="text" name='name_lat' className="form-control"
                               placeholder='Поиск'/>
                    </td>
                    <td></td>
                    <td></td>
                </tr>
                </thead>
                <tbody>
                {rows}
                </tbody>
            </table>

            <Pagination pagesCount={pagination.pagesCount} currentPage={pagination.currentPage}
                        setPageHandler={setCurrentPage}/>
        </>
    )
}